import { Injectable } from '@angular/core';
import {
  NgxExcelModelColumnRule,
  NgxExcelContextChanged,
  NgxExcelRow,
  NgxExcelColumn,
  NgxExcelColumnType,
  NgxExcelSelectOption
} from '../models/models';
import { NgxExcelUploadService } from './ngx-excel-helper';
import { INgxExcelDataSource } from './ngx-excel-data-source';
import { NgxExcelService } from './ngx-excel.service';
import { NgxExcelComponentService } from './ngx-excel-component.service';
import { Observable, of, throwError, Subject, BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { pascalCase } from 'change-case';
import { isUndefined } from 'util';
import * as lodash from 'lodash';

// export type BehaviorActions = 'initial' | 'loading' | 'normal';

export interface BehaviorEvent {
  action: 'metas' | 'appendRow' | 'updateRow' | 'removeRow' | 'error';
  payload?: any;
}

@Injectable()
export class NgxExcelController {

  // public excelRows: NgxExcelRow[] = [];
  // private _loadedPages = new Set<number>();
  // private _excelRowStream = new BehaviorSubject<NgxExcelRow[]>([]);
  private _subscription = new Subscription();
  private _loadedRowCount = 0;
  private _pageNumMax = 0;
  private _total = 0;

  private _cachedForeignModelsMap = new Map<string, any[]>();

  private _selectedExcelCellComponent: any;
  private _selectedExcelRow: NgxExcelRow;
  private _selectedExcelCol: NgxExcelColumn;

  private readonly _subject = new Subject<BehaviorEvent>();
  private readonly _metasSubject = new Subject<{ [name: string]: any }>();
  private _pageSize = 100;
  private _globalFilters: { [name: string]: string | string[] } = {};
  private _extraFilters: { [name: string]: string | string[] } = {};
  private _extraMetas: string[] = [];

  constructor(
    private _dataService: INgxExcelDataSource<any>,
    // private _dataService: NgxExcelService<any>,
    private _componentService: NgxExcelComponentService
  ) { }

  /**
   * å¤æ­æ¯å¦æéå¯¹è¯¥æ¨¡åçæå®æä½æé
   * @param model å¾å¤ççæ¨¡å
   * @param action å¤çå¨ä½
   */
  public privilege(model: any, action: string): boolean {
    const method = 'privilege' + pascalCase(action);
    return isUndefined(this._componentService[method]) ? true : this._componentService[method](model);
  }

  /**
   * å¤æ­æ¯å¦æéå¯¹è¯¥æ¨¡åçæå®æä½è½å
   * @param model å¾å¤ççæ¨¡å
   * @param action å¤çå¨ä½
   */
  public can(model: any, action: string): boolean {
    const method = 'can' + pascalCase(action);
    return isUndefined(this._componentService[method]) ? true : this._componentService[method](model);
  }

  /**
   * å¤æ­æ¯å¦æéå¯¹è¯¥å­æ®µçç¼è¾è½å
   * @param excelRow å¾å¤æ­çæ°æ®è¡
   * @param excelCol å¾å¤ççæ°æ®å
   */
  public canEdit(excelRow: NgxExcelRow, excelCol: NgxExcelColumn): boolean {
    const action = 'Edit' + pascalCase(excelCol.name);
    return this.can(excelRow.context, action);
  }

  /**
   * éªè¯æäº¤æ°æ®çæææ§
   * @param excelRow å¾å¤æ­çæ°æ®è¡
   * @param excelCol å¾å¤æ­çæ°æ®å
   * @param newValue æ°å¼
   */
  public validate(excelRow: NgxExcelRow, excelCol: NgxExcelColumn, newValue: any): boolean | string | Observable<boolean | string> {
    const canEdit = this.canEdit(excelRow, excelCol);
    if (!canEdit) {
      return 'ç¦æ­¢ç¼è¾è¯¥å­æ®µ';
    }

    const method = 'validate' + pascalCase(excelCol.name);
    return typeof (this._componentService[method]) === 'undefined' ? true : this._componentService[method](excelRow.context, newValue);
  }

  /**
   * å¤æ­ååæ ¼æ¯å¦è¢«éä¸­
   * @param excelRow è¡¨æ ¼è¡
   * @param excelCol è¡¨æ ¼å
   */
  public isSelectedCell(excelRow: NgxExcelRow, excelCol: NgxExcelColumn): boolean {
    if (!excelRow.context || !this._selectedExcelCellComponent || !this._selectedExcelRow || !this._selectedExcelCol) {
      return false;
    }
    return this._dataService.getPrimaryKey(excelRow.context) === this._dataService.getPrimaryKey(this._selectedExcelRow.context) &&
      excelCol.name === this._selectedExcelCol.name;
  }

  /**
   * éä¸­ååæ ¼
   * @param component ååæ ¼ç»ä»¶
   * @param excelRow è¡¨æ ¼è¡
   * @param excelCol è¡¨æ ¼å
   */
  public selectCell(component: any, excelRow: NgxExcelRow, excelCol: NgxExcelColumn): boolean {
    if (!excelRow.context) { return false; }
    if (this._selectedExcelCellComponent) {
      this._selectedExcelCellComponent.unselect();
    }
    this._selectedExcelCellComponent = component;
    this._selectedExcelRow = excelRow;
    this._selectedExcelCol = excelCol;
    return true;
  }

  /**
   * è·å¾ææå­æ®µçæ¨¡åè§åï¼æå¡ç©¿éï¼
   */
  /* public getRules(): NgxExcelModelColumnRules<any> {
    return this._excel.getRules();
  } */

  /**
   * è·å¾æå®å­æ®µçæ¨¡åè§åï¼æå¡ç©¿éï¼
   * @param name å­æ®µå
   */
  public getRule(name: string, excel?: NgxExcelService<any>): NgxExcelModelColumnRule<any> {
    const currentExcelService = excel || this._dataService;
    const decimalPos = name.indexOf('.');
    if (decimalPos < 0) {
      return currentExcelService.getRule(name);
    }

    // å¦æ name ä¸­å­å¨å°æ°ç¹ åä¸åè®¸æ¯ç¬¬ä¸ä¸ªææåä¸ä¸ªå­ç¬¦
    if (decimalPos === 0 || decimalPos === name.length - 1) { return null; }
    const nameParts = name.split('.');
    const rule = currentExcelService.getRule(nameParts.shift());
    return rule && rule.relativeService ? this.getRule(nameParts.join('.'), rule.relativeService) : null;
  }

  /**
   * è·å¾æå®æ¨¡åçä¸»é®
   * @param model æ¨¡å
   */
  public getPrimaryKey(context: any): string {
    return this._dataService.getPrimaryKey(context);
  }

  /**
   * è·å¾ä¸æå¯éé¡¹åè¡¨
   * @param excelRow è¡¨æ ¼è¡
   * @param excelCol è¡¨æ ¼å
   */
  public getSelectOptions(excelRow: NgxExcelRow, excelCol: NgxExcelColumn): Observable<NgxExcelSelectOption[]> {
    const name = pascalCase(excelCol.name);
    let observe: Observable<NgxExcelSelectOption[]>;
    if (this._dataService[`get${name}SelectOptions`]) {
      observe = this._dataService[`get${name}SelectOptions`](excelRow.context);
    } else {
      if (!excelCol.selectOptions) {
        return throwError(new Error('æ æ³è·å¾ä¸æéé¡¹'));
      }
      observe = of(excelCol.selectOptions);
    }
    return observe;
  }

  /**
   * è·å¾å¤é®å¯éé¡¹
   * @param excelRow è¡¨æ ¼è¡
   * @param excelCol è¡¨æ ¼å
   * @param keyword å³é®å­
   */
  public getForeignModels(excelRow: NgxExcelRow, excelCol: NgxExcelColumn, keyword: string): Observable<any[]> {
    const name = pascalCase(excelCol.name);
    if (this._cachedForeignModelsMap.has(name)) {
      return of(this._cachedForeignModelsMap.get(name));
    }

    let observe: Observable<any[]>;
    if (this._dataService[`get${name}ForeignModels`]) {
      // èªå®ä¹è·å¾å¤é®å¯éé¡¹
      observe = this._dataService[`get${name}ForeignModels`](excelRow.context, keyword);
    } else if (!excelCol.relativeService) {
      // å¦æè¡¨æ ¼åæªå®ä¹ç¸å³ Service åæåºå¼å¸¸
      return throwError({ message: 'æ æ³ä»æ°æ®æºè·å¾éé¡¹åè¡¨' });
    } else if (keyword === null) {
      // å¦æ å³é®å­ = null è¡¨ç¤ºæ é suggestion æç¤º
      observe = excelCol.relativeService.getList(Object.assign({}, this._extraFilters, { loadCollection: 'true' }));
    } else {
      const params = Object.assign({}, this._extraFilters);
      if (keyword) { params[excelCol.typeaheadKey] = keyword; }
      observe = excelCol.relativeService.getList(params, 1, 20);
    }

    return observe.pipe(
      tap((models) => {
        // suggestion æ¨¡å¼ä¸ä¸åè®¸ç¼å­å¯éé¡¹æ°æ®
        if (keyword !== null || excelCol.disableCache) { return; }
        this._cachedForeignModelsMap.set(name, models);
      })
    );
  }

  /**
   * è·å¾æä»¶ä¸ä¼ æå¡
   * @param item H5ä¸ä¼ å¯¹è±¡
   */
  public getUploadService(payload: { [name: string]: string | Blob }): NgxExcelUploadService {
    // tslint:disable: no-string-literal
    if (isUndefined(this._dataService['getUploadService'])) {
      throw new Error('æ°æ®æå¡ä¸æ¯ææä»¶ä¸ä¼ åè½');
    }
    return this._dataService['getUploadService'](payload);
  }

  /**
   * ç»å®é¢å¤çè¿æ»¤åæ°
   * @param filters è¿æ»¤åæ°åè¡¨
   */
  public bindFilters(filters: { [name: string]: string | string[] }): NgxExcelController {
    this._extraFilters = filters;
    return this;
  }

  /**
   * ç»å®é¢å¤çåæ°æ®åè¡¨
   * @param metas éè¦è¯·æ±çé¢å¤åæ°æ®åè¡¨
   */
  public bindMetas(metas: string | string[]): Observable<{ [name: string]: any }> {
    this._extraMetas = Array.isArray(metas) ? [...metas] : [metas];
    return this._metasSubject as Observable<{ [name: string]: any }>;
  }

  /**
   * ç»å®æ°æ®é
   * @param dataSet å¾ç»å®çæ°æ®é
   */
  public bindDataSet(dataSet: any[]) {
    if (isUndefined(this._dataService['bindDataSet'])) {
      throw new Error('ééææ°æ®å¤çæå¡æ æ³ç»å®æ°æ®é');
    }
    this._dataService['bindDataSet'](dataSet);
  }

  /**
   * è·å¾å®æ´çæ°æ®é
   */
  public getDataSet() {
    return isUndefined(this._dataService['getDataSet']) ? [] : this._dataService['getDataSet']();
  }

  /**
   * å¢å å
   * @param column å¨æå¢å åå®ä¹
   * @param index å¢å çä½åºï¼é»è®¤å¨æåå¢å ï¼
   */
  public resolveColumn(column: NgxExcelColumn): NgxExcelColumn {
    const rule = this.getRule(column.name);
    column.label = column.label || lodash.get(rule, 'label', '');
    column.columnType = lodash.get(rule, 'columnType', NgxExcelColumnType.Text);
    column.allowNegative = lodash.get(rule, 'allowNegative', false);
    column.optional = lodash.get(rule, 'optional', false);
    if (rule) {
      if (column.columnType === NgxExcelColumnType.ForeignKey || column.columnType === NgxExcelColumnType.MultiForeignKey) {
        column.selectOptions = lodash.get(rule, 'selectOptions', []);
        column.relativeService = lodash.get(rule, 'relativeService', null);
        column.labelKey = lodash.get(rule, 'labelKey', 'label');
        column.typeaheadKey = lodash.get(rule, 'typeaheadKey', '');
        column.disableCache = lodash.get(rule, 'disableCache', false);
        column.acceptedFileType = '';
        column.acceptedFileSize = 0;
        column.acceptedFileCount = 1;
        column.acceptedSelectedCount = column.columnType === NgxExcelColumnType.MultiForeignKey ?
          lodash.get(rule, 'acceptedSelectedCount', 0) : 0;
        column.acceptedWordCount = 0;
      } else if (column.columnType === NgxExcelColumnType.UploadFile || column.columnType === NgxExcelColumnType.MultiUploadFile) {
        column.selectOptions = lodash.get(rule, 'selectOptions', []);
        column.relativeService = null;
        column.labelKey = 'label';
        column.typeaheadKey = '';
        column.disableCache = true;
        column.acceptedFileType = lodash.get(rule, 'acceptedFileType', '');
        column.acceptedFileSize = lodash.get(rule, 'acceptedFileSize', 0);
        column.acceptedFileCount = column.columnType === NgxExcelColumnType.MultiUploadFile ?
          lodash.get(rule, 'acceptedFileCount', 3) : 1;
        column.acceptedSelectedCount = 0;
        column.acceptedWordCount = 0;
      } else {
        column.selectOptions = lodash.get(rule, 'selectOptions', []);
        column.relativeService = null;
        column.labelKey = 'label';
        column.typeaheadKey = '';
        column.disableCache = true;
        column.acceptedFileType = '';
        column.acceptedFileSize = 0;
        column.acceptedFileCount = 1;
        column.acceptedSelectedCount = column.columnType === NgxExcelColumnType.MultiSelectOption ?
          lodash.get(rule, 'acceptedSelectedCount', 0) : 0;
        column.acceptedWordCount = column.columnType === NgxExcelColumnType.MultilineText ?
          lodash.get(rule, 'acceptedWordCount', 0) : 0;
      }
    } else {
      column.selectOptions = [];
      column.relativeService = null;
      column.labelKey = '';
      column.typeaheadKey = '';
      column.disableCache = true;
      column.acceptedFileType = '';
      column.acceptedFileSize = 0;
      column.acceptedFileCount = 1;
      column.acceptedSelectedCount = 0;
      column.acceptedWordCount = 0;
    }

    return column.label.length > 0 ? column : null;
  }

  /**
   * æ ¹æ®è¡å·å è½½è¡¨æ ¼è¡
   * @param lineNumBegin å¼å§è¡å·
   * @param lineNumEnd ç»æè¡å·
   */
  public loadRows(lineNumBegin: number, lineNumEnd: number): Observable<{ excelRows: NgxExcelRow[], total: number }> {
    const pageNumBegin = this._getPageForIndex(lineNumBegin);
    const pageNumEnd = this._getPageForIndex(lineNumEnd);
    const queue: Observable<{ excelRows: NgxExcelRow[], pageNum: number }>[] = [];
    for (let i = pageNumBegin; i <= pageNumEnd; i++) { queue.push(this._loadPage(i)); }
    /* return forkJoin(queue).subscribe(
      () => this._subject.next({ action: 'loadedSuccess', payload: { total: this._expectedTotal, loadedCount: this._loadedRowCount } }),
      (e) => this._subject.next({ action: 'error', payload: e })
    ); */
    return forkJoin(queue).pipe(
      map((resultSet) => {
        const length = resultSet.map((result) => result.excelRows.length).reduce((previous, current) => previous + current, 0);
        const excelRows: NgxExcelRow[] = Array.from<any, NgxExcelRow>({ length }, (_, __) => this.createExcelRow(null, -1));
        resultSet.forEach((result, i) =>
          excelRows.splice(i * this._pageSize, result.excelRows.length, ...result.excelRows)
        );
        return { excelRows, total: this._total };
      })
    );
  }

  /**
   * å¤çä¸ä¸æèåç¹å»äºä»¶
   * @param action å¨ä½
   * @param model æ¨¡å
   */
  public handleContextMenuClick(action: string, model?: any): Observable<NgxExcelContextChanged[]> {
    if (isUndefined(this._componentService[action])) { return null; }
    return this._componentService[action](model ? Object.assign({}, model, this._extraFilters) : null);
  }

  /**
   * å¤çæ¨¡ååæ´
   * @param originalModel åå§çæ¨¡å
   * @param model ä¿®æ¹åçæ¨¡å
   * @param name æ´æ°å­æ®µå
   */
  public handleModelChanged(originalModel: any, model: any, name: string): Observable<NgxExcelContextChanged[]> {
    // å¦æå¼æ²¡æåçåå åè·³è¿æäº¤
    // console.log(this._dataService, originalModel[name], model[name]);
    if (lodash.get(originalModel, name) === lodash.get(model, name)) {
      return of([{ action: 'updated', context: lodash.clone(model) }]);
    }

    // å®ä¹äº handleNameChange åç´æ¥è°ç¨æ¹æ³è¿å
    const changeMethod = 'handle' + pascalCase(name) + 'Change';
    if (!isUndefined(this._componentService[changeMethod])) {
      return this._componentService[changeMethod](originalModel, Object.assign(model, this._extraFilters), name);
    }

    // å®ä¹äº handleNameChanged åç´æ¥è°ç¨æ¹æ³è¿å
    const changedMethod = 'handle' + pascalCase(name) + 'Changed';
    if (!isUndefined(this._componentService[changedMethod])) {
      return this._componentService[changedMethod](originalModel, Object.assign(model, this._extraFilters), name);
    }
    // å¦ææ²¡æå®ä¹ ä¿®æ¹ç½åå (autoCommitKeys) åè·³è¿æäº¤
    if (this._componentService.autoCommitKeys.indexOf(name) < 0) {
      return of([{ action: 'updated', context: lodash.clone(model) }]);
    }

    const primaryKey = this._dataService.getPrimaryKey(model);
    // åªæäº¤åè®¸èªå¨æ´æ°çå¼
    const payload = {};
    const object = Object.assign({}, model, this._extraFilters);
    this._componentService.autoCommitKeys.forEach((autoCommitKey) => {
      payload[autoCommitKey] = lodash.get(object, autoCommitKey);
    });
    return this._dataService.save(payload, primaryKey).pipe(
      map((changedContext) => {
        return [{ action: 'updated', context: changedContext }];
      })
    );
  }

  /**
   * å¢å ä¸ä¸ªæ°æ®è¡
   * @param context è¡åå®¹
   * @param i è¡å·
   */
  public createExcelRow(context: any, i: number): NgxExcelRow {
    return {
      i, y: -1, visible: false, context: context || null,
      primaryKey: context ? this._dataService.getPrimaryKey(context) : '',
    } as NgxExcelRow;
  }

  /**
   * è®¡ç®é¡µç 
   * @param lineNum è¡å·
   */
  private _getPageForIndex(lineNum: number) {
    return Math.floor(lineNum / this._pageSize);
  }

  /**
   * å è½½é¡µ
   * @param pageNum é¡µç ä» 0 å¼å§
   */
  private _loadPage(pageNum: number): Observable<{ excelRows: NgxExcelRow[], pageNum: number }> {
    // é¡µç å°äº 0 è¿åç©ºéå
    if (pageNum < 0) {
      return throwError(new Error('è¯·æ±åæ°éè¯¯ï¼è¯·æ±é¡µç æº¢åº'));
    }

    // æ´çè¯·æ±åæ°
    const initial = pageNum === 0;
    if (initial) {
      this._total = 0;
      this._pageNumMax = 0;
    }
    // const initial = this._total === 0 || this._pageNumMax === 0;
    const queryParams = Object.assign({}, this._extraFilters) as { [name: string]: string | string[] };
    queryParams.meta = [...this._extraMetas];
    if (initial) {
      if (queryParams.meta.indexOf('total') < 0) {
        (queryParams.meta as string[]).push('total');
      }
    } else {
      if (pageNum >= this._pageNumMax) {
        return throwError(new Error('è¯·æ±åæ°éè¯¯ï¼è¯·æ±é¡µç æº¢åº'));
      }
    }

    if (queryParams.meta.length > 0) {
      queryParams.meta = (queryParams.meta as string[]).join(',');
    } else {
      delete queryParams.meta;
    }

    return this._dataService.getList(queryParams, pageNum + 1, this._pageSize).pipe(
      tap(() => {
        const responseMetas = this._dataService.getResponseMetas();
        if (initial) {
          if (isUndefined(responseMetas.total)) {
            throw new Error('æå¡å¨ååºéè¯¯ï¼æªç¥çæ°æ®æ»æ°');
          } else if (!responseMetas.total) {
            throw null;
          }
          this._total = responseMetas.total;
          this._pageNumMax = Math.ceil(this._total / this._pageSize);
        }
        this._metasSubject.next(responseMetas);
      }),
      map((contexts) => ({
        excelRows: contexts.map((context, i) => this.createExcelRow(context, pageNum * this._pageSize + i)),
        pageNum
      })),
    );
  }

}
